// Everything here only pushes to the GTM dataLayer. Tags (Google tag, Ads conversion,
// Meta Pixel) live in GTM container GTM-TP3NSMB, see gtm/README.md.

const push = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const pushEcommerce = (event, ecommerce) => {
  push({ ecommerce: null }); // clear the previous ecommerce object
  push({ event, ecommerce: { currency: 'INR', ...ecommerce } });
};

// Cart/order line -> GA4-style item
export const toTrackingItem = (item) => ({
  item_id: String(item.id ?? item.item_id),
  item_name: item.name ?? item.item_name,
  price: Number(item.offer_price ?? item.price) || 0,
  quantity: Number(item.quantity) || 1,
});

/**
 * SPA route changes do not reload the page, so GTM never sees a new "Page View".
 * This pushes one on every client-side navigation (the first load is covered by gtm.js).
 */
export function trackVirtualPageView(path) {
  push({
    event: 'virtual_page_view',
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackViewItem(product) {
  if (!product?.id) return;
  const price = Number(product.sale_price) || 0;
  pushEcommerce('view_item', {
    value: price,
    items: [{ item_id: String(product.id), item_name: product.title, price, quantity: 1 }],
  });
}

export function trackAddToCart(items) {
  const lines = (items || []).filter((i) => i && (i.id ?? i.item_id));
  if (!lines.length) return;
  const mapped = lines.map(toTrackingItem);
  pushEcommerce('add_to_cart', {
    value: mapped.reduce((sum, i) => sum + i.price * i.quantity, 0),
    items: mapped,
  });
}

export function trackBeginCheckout(cart, value) {
  const products = cart?.products || [];
  if (!products.length) return;
  pushEcommerce('begin_checkout', { value, items: products.map(toTrackingItem) });
}

/**
 * Fires the purchase once per order as a dataLayer 'purchase' event.
 * GTM owns everything downstream (Google Ads conversion, Meta Purchase, GA4);
 * transaction_id lets Google Ads de-duplicate repeats of the same order.
 */
export function trackPurchase(order) {
  if (!order?.transactionId) return;

  const firedKey = `conv_fired_${order.transactionId}`;
  try {
    if (sessionStorage.getItem(firedKey)) return; // page refresh / back navigation
    sessionStorage.setItem(firedKey, '1');
  } catch (e) {}

  pushEcommerce('purchase', {
    transaction_id: order.transactionId,
    value: order.value,
    payment_type: order.paymentType,
    items: order.items,
  });
}
